import { ReactElement } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { UserPermission } from '../../enum/userPermissions';
import useSessionUser from '../../hooks/useSessionUser';
import { hasOnePermissionToAccess, hasPermission } from '../../services/users/identity/user.service';

interface AdminRouteProps extends RouteProps {
  permission?: UserPermission | UserPermission[];
  checkAdminPanelManagePermission?: boolean | true;
}

function AdminRoute({ permission, checkAdminPanelManagePermission, ...rest }: AdminRouteProps): ReactElement {
  const { user } = useSessionUser();
  const canAccess: boolean = permission ? hasOnePermissionToAccess(user, permission) : true;

  return user && (!checkAdminPanelManagePermission || hasPermission(user, UserPermission.AdminPanelManage)) && canAccess ? (
    <Route {...rest} />
  ) : (
    <Redirect to={'/'} />
  );
}

export default AdminRoute;
